<template>
  <div>
    <v-navigation-drawer v-model="drawer" :clipped="$vuetify.breakpoint.lgAndUp" app>
      <v-list dense>
        <template v-for="item in items">
          <v-row v-if="item.heading && (!item.ownerOnly || esPropietario)" :key="item.heading" align="center">
            <v-col cols="6">
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-col>
          </v-row>
          <v-list-group v-else-if="item.children && (!item.ownerOnly || esPropietario)" :key="item.text" v-model="item.model"
            :prepend-icon="item.model ? item.icon : item['icon-alt']" append-icon="">
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>
                  <v-badge v-if="item.nuevo" color="primary" content="Nuevo">
                    {{ item.text }}
                  </v-badge>
                  <span v-if="!item.nuevo">
                    {{ item.text }}
                  </span>
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item v-for="(child, i) in item.children" :key="i" :to="child.to" link>
              <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  <v-badge v-if="child.nuevo" color="primary" content="Nuevo">
                    {{ child.text }}
                  </v-badge>
                  <span v-if="!child.nuevo">
                    {{ child.text }}
                  </span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item v-else-if="!item.ownerOnly || esPropietario" :key="item.text" :to="item.to" link>
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                <v-badge v-if="item.nuevo" color="primary" content="Nuevo">
                  {{ item.text }}
                </v-badge>
                <span v-if="!item.nuevo">
                  {{ item.text }}
                </span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
      <v-list dense>
        <v-list-item-group>
          <v-list-item @click="cambiaTema" link>
            <v-list-item-icon>
              <v-icon>mdi-theme-light-dark</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                <span> Alternar tema </span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

        </v-list-item-group>
      </v-list>

      <div></div>
    </v-navigation-drawer>
  </div>
</template>
<script>
import Vuex from "vuex";
export default {
  name: "NavigationDrawer",
  computed: {
    esPropietario() {
      return sessionStorage.getItem("esPropietario") === "true";
    },
    drawer: {
      get() {
        return this.$store.state.drawer;
      },
      set(newDraweState) {
        this.UPDATE_DRAWER_STATE(newDraweState);
        return newDraweState;
      },
    },
  },

  data: () => ({
    items: [
      {
        icon: "mdi-human-queue",
        text: "Fila de espera",
        nuevo: false,
        to: "/App/Fila",
      },
      {
        icon: "mdi-human-queue",
        text: "Reservaciones",
        nuevo: false,
        to: "/App/Reservaciones",
      },
      {
        icon: "mdi-view-grid-outline",
        text: "Secciones",
        nuevo: false,
        ownerOnly: true,
        to: "/App/Secciones",
      },
      {
        icon: "mdi-map-search-outline",
        text: "Visualizador de secciones",
        nuevo: false,
        to: "/App/VisualizadorSecciones",
      },
      {
        icon: "mdi-account-multiple-plus",
        text: "Compartir instancia",
        to: "/App/CompartirInstancia",
        ownerOnly: true,
        nuevo: false,
      },
      {
        icon: "mdi-cog",
        text: "Espacios de trabajo",
        to: "/App/Instancias",
        nuevo: false,
      },
    ],
  }),
  methods: {
    ...Vuex.mapMutations(["UPDATE_DRAWER_STATE"]),
    cambiaTema() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      sessionStorage.setItem("isDark", this.$vuetify.theme.dark);
    },
  },
  mounted() {
    var dark = sessionStorage.getItem("isDark");
    if (dark !== undefined) this.$vuetify.theme.dark = dark;
  },
};
</script>
